module.exports = __webpack_public_path__ + "static/img/004.2cb4900.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cooperator/004.png
// module id = FEkt
// module chunks = 0